'use client'

import { IProduct } from '@/app/[locale]/_types'
import { useBreakpointValue } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import React from 'react'
import Table from './variants/Table'
import Popover from './variants/Popover'

const Nutrients = ({ data }: { data: IProduct | null | undefined }) => {
  const t = useTranslations()
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  if (!data) {
    return null
  }

  const nutrients = [
    { value: data.energy, label: t('kcal') },
    { value: data.proteins, label: t('proteins') },
    { value: data.fats, label: t('fats') },
    { value: data.carbohydrates, label: t('carbohydrates') },
  ]

  if (isDesktop) {
    return <Popover data={nutrients} />
  }

  return <Table data={nutrients} />
}

export default Nutrients
